interface Props {
  messages: string[];
  connected?: boolean;
}

const POSITIVE_KEYWORDS = ['保持', '完美', '非常好', '不错', '继续', '很好'];

function isPositive(msg: string) {
  return POSITIVE_KEYWORDS.some((kw) => msg.includes(kw));
}

export function FeedbackPanel({ messages, connected = false }: Props) {
  const latest = messages[0];

  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2.5">
          <div className="w-7 h-7 rounded-lg bg-[var(--mx-accent-soft)] border border-[var(--mx-accent-border)] flex items-center justify-center">
            <svg className="w-3.5 h-3.5 text-[var(--mx-accent)]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.75}
                d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
            </svg>
          </div>
          <div>
            <p className="text-xs font-medium text-[var(--mx-text)]">AI 教练</p>
            <p className="text-[10px] text-[var(--mx-text-muted)]">实时姿态反馈</p>
          </div>
        </div>
        {connected && (
          <span className="text-[10px] text-[var(--mx-text-muted)] tabular-nums">{messages.length} 条</span>
        )}
      </div>

      <div className="flex flex-col gap-2 min-h-[88px]">
        {!latest ? (
          <div className="flex flex-col items-center justify-center gap-2 py-6 rounded-xl border border-dashed border-[var(--mx-border)] bg-[var(--mx-bg-elevated)]">
            <div className="w-8 h-8 rounded-full border border-[var(--mx-border)] flex items-center justify-center">
              <div className="w-1.5 h-1.5 rounded-full bg-[var(--mx-text-muted)] animate-pulse" />
            </div>
            <p className="text-xs text-[var(--mx-text-muted)]">{connected ? '分析中，请保持入镜…' : '连接后开始反馈'}</p>
          </div>
        ) : (
          <>
            <div
              className={`rounded-xl px-3.5 py-3 border ${
                isPositive(latest)
                  ? 'bg-[var(--mx-accent-soft)] border-[var(--mx-accent-border)]'
                  : 'bg-[rgba(201,165,92,0.08)] border-[rgba(201,165,92,0.22)]'
              }`}
            >
              <div className="flex items-start gap-2.5">
                <span
                  className={`mt-0.5 shrink-0 w-5 h-5 rounded-md flex items-center justify-center text-[10px] font-semibold ${
                    isPositive(latest)
                      ? 'bg-[var(--mx-accent-soft)] text-[var(--mx-accent)]'
                      : 'bg-[rgba(201,165,92,0.12)] text-[var(--mx-warning)]'
                  }`}
                >
                  {isPositive(latest) ? '✓' : '!'}
                </span>
                <p className={`text-sm leading-relaxed ${
                  isPositive(latest) ? 'text-[var(--mx-text)]' : 'text-[var(--mx-text-secondary)]'
                }`}>
                  {latest}
                </p>
              </div>
            </div>

            {messages.slice(1, 3).map((msg, i) => (
              <div
                key={i}
                className="flex items-start gap-2 px-3 py-2 rounded-lg bg-[var(--mx-bg-elevated)] border border-[var(--mx-border-subtle)]"
              >
                <span className="text-[10px] text-[var(--mx-text-muted)] mt-0.5 shrink-0">·</span>
                <p className="text-xs text-[var(--mx-text-secondary)] leading-relaxed">{msg}</p>
              </div>
            ))}
          </>
        )}
      </div>
    </div>
  );
}
